var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamerabutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 30.375C35.875 30.9717 35.6379 31.544 35.216 31.966C34.794 32.3879 34.2217 32.625 33.625 32.625H13.375C12.7783 32.625 12.206 32.3879 11.784 31.966C11.3621 31.544 11.125 30.9717 11.125 30.375V18C11.125 17.4033 11.3621 16.831 11.784 16.409C12.206 15.9871 12.7783 15.75 13.375 15.75H17.875L20.125 12.375H26.875L29.125 15.75H33.625C34.2217 15.75 34.794 15.9871 35.216 16.409C35.6379 16.831 35.875 17.4033 35.875 18V30.375Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28.125C25.9853 28.125 28 26.1103 28 23.625C28 21.1397 25.9853 19.125 23.5 19.125C21.0147 19.125 19 21.1397 19 23.625C19 26.1103 21.0147 28.125 23.5 28.125Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamerabutton);
export default __webpack_public_path__ + "static/media/camerabutton.1d8c751c1dbe2941319d4356299985da.svg";
export { ForwardRef as ReactComponent };